export const contactForms = {
  EMERGENCY_MAPPING: 'emergencymapping@unosat.org',
  MEDIA: 'unosatmedia@unitar.org',
  GENERAL: 'unosat@unitar.org',
};
